import {
  Module,
  VuexModule,
  getModule,
  Action} from 'vuex-module-decorators';
import store from '@/store';
import { DisclaimerTextResponseDto, GetDisclaimerRequest } from '../models';
import {
  getDisclaimerText,
  validateSalesToken
} from '../api';

@Module({
  dynamic: true,
  namespaced: true,
  name: 'privacyConfirmModule',
  store
})
class PrivacyConfirmModule extends VuexModule {

  @Action({ rawError: true })
  public async getDisclaimer(request: GetDisclaimerRequest): Promise<DisclaimerTextResponseDto> {
    return await getDisclaimerText(request);
  }

  @Action({ rawError: true })
  public async validateTestUserToken(salesToken: string) {
    try {
      const valid = await validateSalesToken(salesToken);
      return valid;
    } catch (error) {
      throw new Error(error as string);
    }
  }
}

export default getModule(PrivacyConfirmModule);
